/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItemDialog extends Serenity.Extensions.GridEditorDialog<PsAdvPromoItemRow> {

        // static from: string;
        protected getFormKey() { return PsAdvPromoItemForm.formKey; }
        // protected getIdProperty() { return PsAdvPromoItemRow.idProperty; }
        protected getLocalTextPrefix() { return PsAdvPromoItemRow.localTextPrefix; }
        protected getNameProperty() { return PsAdvPromoItemRow.nameProperty; }
        protected getService() { return PsAdvPromoItemService.baseUrl; }
        // protected getDeletePermission() { return PsAdvPromoItemRow.deletePermission; }
        // protected getInsertPermission() { return PsAdvPromoItemRow.insertPermission; }
        // protected getUpdatePermission() { return PsAdvPromoItemRow.updatePermission; }

        protected form = new PsAdvPromoItemForm(this.idPrefix);
        
        private pass: string

        public get Pass(): string { return this.pass }
        set Pass(value: string) { this.pass = value; }

        constructor() {
            super();

            this.form.EndBillPmType.changeSelect2(e => {
                let Fg = Q.toId(this.form.EndBillPmType.value)
                if (Fg == "0") {
                    
                    Serenity.EditorUtils.setReadOnly(this.form.Qty, false);
                    Serenity.EditorUtils.setReadOnly(this.form.Amt, true);
                    this.form.Amt.value = null;
                }else{
                    Serenity.EditorUtils.setReadOnly(this.form.Qty, true);
                    Serenity.EditorUtils.setReadOnly(this.form.Amt, false);
                    this.form.Qty.value = null;
                }
                
            });
            //

            this.form.FreeLpFg.changeSelect2(e => {
                let Fg = Q.toId(this.form.FreeLpFg.value)
                if (Fg == "0") {
                    
                    // Serenity.EditorUtils.setReadOnly(this.form.Qty, false);
                    Serenity.EditorUtils.setReadOnly(this.form.LpPrice, true);
                    this.form.LpPrice.value = null;
                }else{
                    // Serenity.EditorUtils.setReadOnly(this.form.Qty, true);
                    Serenity.EditorUtils.setReadOnly(this.form.LpPrice, false);
                }
                
            });

            

            this.form.PluCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.PluCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 1
                    this.form.StyleCode.value = null
                    this.form.CatCode.value = null
                    this.form.SubCat1Code.value = null
                    this.form.SubCat2Code.value = null
                    this.form.BrandCode.value = null
                    this.form.SupplCode.value = null
                }
                if (Fg = null) {
                    // this.form.ListFg.value = 0
                }
            });
            this.form.StyleCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.StyleCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 0
                    this.form.PluCode.value = null
                }
                
            });
            this.form.CatCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.CatCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 0
                    this.form.PluCode.value = null
                }
                
            });
            this.form.SubCat1Code.changeSelect2(e => {
                let Fg = Q.toId(this.form.SubCat1Code.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 0
                    this.form.PluCode.value = null
                }
                
            });
            this.form.SubCat2Code.changeSelect2(e => {
                let Fg = Q.toId(this.form.SubCat2Code.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 0
                    this.form.PluCode.value = null
                }
                
            });
            this.form.SupplCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.SupplCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 0
                    this.form.PluCode.value = null
                }
                
            });
            this.form.BrandCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.BrandCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 0
                    this.form.PluCode.value = null
                }
                
            });

            this.form.PmExtCode.changeSelect2(e => {
                let ex = Q.toId(this.form.PmExtCode.value)
                let gp = Q.toId(this.form.PmGroupId.value)
                this.form.PmId.value = ex + gp;
            });

            this.form.ListFg.changeSelect2(e => {
                this.ListFgCheck();
            });

        }
        



        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 0);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "clone-button"), 0);
            // buttons.push({
            //     title: 'Clone',
            //     cssClass: 'clone-button',
            //     icon: 'fa-copy',
            //     onClick: () => {

            //       var cloneEntity = this.getCloningEntity();

            //       Serenity.Widget.create({
            //         type: (ss as any).getInstanceType(this),
            //         init: w => Serenity.SubDialogHelper.bubbleDataChange(Serenity.SubDialogHelper.cascade(w, this.element), this, true).loadEntityAndOpenDialog(cloneEntity, false)
            //       });
            //     }
            //   });
            // let newBtn: Serenity.ToolButton =
            // {
            //     title: "บันทึก",
            //     hint: "Save and new",
            //     separator: false,
            //     cssClass: "button-save",
            //     icon: "fa fa-save",
            //     hotkey: 'alt+shift+s',
            //     onClick: () => {
            //         // const dialog = new PsAdvPromoItemExemptDialog()
            //         // dialog.PmId = this.form.PmId.value,
            //         // dialog.PmGroupId = this.form.PmGroupId.value,
            //         // dialog.PmExtCode = this.form.PmExtCode.value,
            //         // dialog.PmDesc = this.form.PmDesc.value,
            //         // dialog.ItemType = this.form.ItemType.value
                        
                       
            //         // PsAdvPromoHdRetrieveHandler ต้องการ รีgrid exlist เมื่อกดเซฟ
            //         this.save((response) => {
            //             // Serenity.SubDialogHelper.triggerDataChange(dialog);
            //             this.dialogClose();

            //         });
            //     }
            // };
            // buttons.push(newBtn);
           
            //Te Check
            //ต้องการPopup หลังปุ่ม เป็นการ ค้างข้อมูลเดิม และเกิดค้างไว้ / บันทึกและปิด
            let newitem: Serenity.ToolButton =
            {
                title: "เพิ่ม&ใช้ข้อมูลเดิม",
                hint: "add and new [alt+s]",
                separator: false,
                cssClass: "button-addandnew",
                icon: "fa fa-save",
                hotkey: 'alt+s',
                onClick: () => {
                    var s = this.Checkbeforsave();
                    if (s) {

                    }

                    else {
                    Q.confirm('ยืนยันการเพิ่ม'
                    +"\r\n" +"โดยคงค่าข้อมูลเดิม และ Step no.+1"
                    , () => {

                    // e.preventDefault();
                    this.saveAndNew();
                    this.ListFgCheck();
                    
                    });}
                }
            };
            buttons.push(newitem);
            let newitem2: Serenity.ToolButton =
            {
                title: "เพิ่ม&สร้างใหม่",
                hint: "add and clear [alt+a]",
                separator: false,
                cssClass: "button-addandclear",
                icon: "fa fa-save",
                hotkey: 'alt+a',
                onClick: (e) => {
                    var s = this.Checkbeforsave();
                    if (s) {

                    }

                    else {
                    
                    e.preventDefault();
                    Q.confirm('ยืนยันการเพิ่ม และสร้างรายการใหม่ทั้งหมด'
                    +"\r\n" +"โดย ล้างรายการที่ป้อนทั้งหมด", () => {

                    this.saveAndclear();
                    
                    this.ListFgCheck();
                    // this.dialogClose();
                    });}
                }
            };
            buttons.push(newitem2);
            // buttons.push({
            //     title: 'เพิ่มสินค้ายกเว้น',
            //     cssClass: 'itemexempt-button',
            //     icon: 'fa-ban text-red',
            //     onClick: () => {
            //         // new PsAdvPromoItemExemptDialog().loadEntityAndOpenDialog(
            //         //     <PsAdvPromoItemExemptRow>{
            //         //         PmId: this.entity.PmId,
            //         //         PmGroupId: this.entity.PmGroupId,
            //         //         PmExtCode: this.entity.PmExtCode,
            //         //         PmDesc: this.entity.PmDesc,
            //         //         ItemType: this.entity.ItemType

            //         //     }
                    

                    
            //         const dialog = new PsAdvPromoItemExemptDialog()
            //         dialog.PmId = this.form.PmId.value,
            //             dialog.PmGroupId = this.form.PmGroupId.value,
            //             dialog.PmExtCode = this.form.PmExtCode.value,
            //             dialog.PmDesc = this.form.PmDesc.value,
            //             dialog.ItemType = this.form.ItemType.value
            //         dialog.loadNewAndOpenDialog()
                    
            //     }
            // });

            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );
            return buttons;
        }

        private saveAndNew() {
            let e = this.entity; let f = this.form;
             
            if (f.PmStepNo == null) {
                var pmstep = f.PmStepNo.value;
            }else{
                var pmstep = f.PmStepNo.value+1;
            }
            this.save((response) => {
                let ent: PsAdvPromoItemRow = { 
                    PmGroupId: f.PmGroupId.value,
                    PmId:f.PmId.value, 
                    PmType:f.PmType.value,
                    PmExtCode: f.PmExtCode.value,
                    PmStepNo: pmstep,
                    PmDesc: f.PmDesc.value,

                    ItemType: Number(f.ItemType.value),
                    AssortFg: Number(f.AssortFg.value),
                    EndBillPmType: Number(f.EndBillPmType.value),
                    Qty: f.Qty.value,
                    Amt: f.Amt.value,
                    FreeLpFg: Number(f.FreeLpFg.value),
                    FreeQty: f.FreeQty.value,
                    LpPrice: f.LpPrice.value,

                    ListFg: Number(f.ListFg.value),
                    PluCode: f.PluCode.value,
                    StyleCode: f.StyleCode.value,
                    BrandCode: f.BrandCode.value,
                    CatCode: f.CatCode.value,
                    SubCat1Code: f.SubCat1Code.value,
                    SubCat2Code: f.SubCat2Code.value,
                    SupplCode: f.SupplCode.value
                };
                this.loadEntity(ent);

                this.FreefgCheck();
                this.ListFgCheck();
            });
            
        }
        private saveAndclear() {
            let e = this.entity; let f = this.form;
            // if (e.SkuCode == null) {
            //     e.SkuCode = f.SkuCode.value;

            // }
            this.save((response) => {
                let ent: PsAdvPromoItemRow = { 
                    PmGroupId: e.PmGroupId,
                    PmType:e.PmType,
                    EndBillPmType: 0,
                    FreeLpFg: 0                    
                };
                this.loadEntity(ent);
                this.FreefgCheck();
                this.ListFgCheck();
            });
            
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
                this.FreefgCheck();
                this.ListFgCheck();
            if (this.isNew()) {
                this.form.PmGroupId.value = this.pass                
            }
            
        }


        private FreefgCheck() {
            let ex = Q.toId(this.form.FreeLpFg.value)
            if (ex == 0) {
                Serenity.EditorUtils.setReadOnly(this.form.LpPrice, true);
            }
            if (ex == 1) {
                Serenity.EditorUtils.setReadOnly(this.form.LpPrice, false);
                //this.form.LpPrice.value = null
            }

            let data = Q.toId(this.form.EndBillPmType.value)
            if (data == 0) {
                Serenity.EditorUtils.setReadOnly(this.form.Qty, false);
                Serenity.EditorUtils.setReadOnly(this.form.Amt, true);

            }
            if (data == 1) {
                Serenity.EditorUtils.setReadOnly(this.form.Qty, true);
                Serenity.EditorUtils.setReadOnly(this.form.Amt, false);
            }
        }

        private ListFgCheck() {
            let ex = Q.toId(this.form.ListFg.value)
            if (ex == 2) {
                Serenity.EditorUtils.setReadOnly(this.form.PluCode, true);

                Serenity.EditorUtils.setReadOnly(this.form.StyleCode, false);
                Serenity.EditorUtils.setReadOnly(this.form.CatCode, false);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat1Code, false);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat2Code, false);
                Serenity.EditorUtils.setReadOnly(this.form.BrandCode, false);
                Serenity.EditorUtils.setReadOnly(this.form.SupplCode, false);
                this.form.PluCode.value = null
            }
            if (ex == 1) {
                Serenity.EditorUtils.setReadOnly(this.form.StyleCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.CatCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat1Code, true);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat2Code, true);
                Serenity.EditorUtils.setReadOnly(this.form.BrandCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.SupplCode, true);

                Serenity.EditorUtils.setReadOnly(this.form.PluCode, false);
                this.form.StyleCode.value = null
                this.form.CatCode.value = null
                this.form.SubCat1Code.value = null
                this.form.SubCat2Code.value = null
                this.form.BrandCode.value = null
                this.form.SupplCode.value = null
            }
            if (ex == 0) {
                Serenity.EditorUtils.setReadOnly(this.form.StyleCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.CatCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat1Code, true);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat2Code, true);
                Serenity.EditorUtils.setReadOnly(this.form.BrandCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.SupplCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.PluCode, true);
                this.form.StyleCode.value = null
                this.form.CatCode.value = null
                this.form.SubCat1Code.value = null
                this.form.SubCat2Code.value = null
                this.form.BrandCode.value = null
                this.form.SupplCode.value = null
                this.form.PluCode.value = null
            }
        }

        private Checkbeforsave() {

            if (this.form.Qty.value == null && this.form.Amt.value == null) {
                Q.warning("โปรด ใส่เงื่อนไขการซื้อ");
                return true
            }

            else if (this.form.FreeQty.value == null ) {
                Q.warning("โปรด ใส่จำนวนสินค้าฟรี");
                return true
            }

            
            else {
                if (this.form.ListFg.value == "1" && this.form.PluCode.value == "") {
                    Q.warning("โปรด เลือกสินค้า")
                    return true
                }
                else if (this.form.ListFg.value == "2" &&
                    this.form.StyleCode.value == "" && this.form.CatCode.value == ""
                    && this.form.SubCat1Code.value == "" && this.form.SubCat2Code.value == ""
                    && this.form.BrandCode.value == "" && this.form.SupplCode.value == "") {
                    Q.warning("โปรด ระบุเกณฑ์สินค้า")
                    return true
                }
                else {
                    return false
                }
            }





        }

    }
}